<footer class="footer-section">
  <div class="footer-divider"></div>

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-8">
    <div class="footer-grid">
      <div class="footer-brand">
        <div class="footer-brand__row cursor-pointer" (click)="goHome()">
          <img class="footer-brand__logo" src="brand/trieon-tech-logo.png" alt="" width="40" height="40" />
          <span class="footer-brand__name">
            <span class="footer-brand__title">Trieon</span>
            <span class="footer-brand__suffix">Technologies</span>
          </span>
        </div>
        <p class="footer-brand__copy">
          Software company building web platforms, mobile apps, and business systems —
          from idea to production.
        </p>
        <a class="footer-email" href="mailto:business@trieon.tech">business@trieon.tech</a>
        <p class="footer-address">San Antonio Ave., Brgy. San Antonio, Parañaque City, Philippines</p>
      </div>

      <div>
        <h4 class="footer-col-title">Explore</h4>
        <ul class="footer-list">
          @for (item of links; track item.label) {
            <li>
              <a class="footer-link cursor-pointer" (click)="goToSection(item.href)">{{ item.label }}</a>
            </li>
          }
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      <p>&copy; {{ currentYear }} Trieon Technologies. All rights reserved.</p>
      <p class="footer-bottom__note">Philippines · Software Company</p>
    </div>
  </div>
</footer>
